// extracted by mini-css-extract-plugin
module.exports = {"container":"QuizIntro_container__2CDIZ","man":"QuizIntro_man__3XGCh","text":"QuizIntro_text__2Bm4H","start":"QuizIntro_start__28Eo_"};